import {
    APP_BY_ID,
    APP_ICON,
    APP_SCREENSHOTS,
    APP_VIDEO,
    APP_VERSIONS,
    UPDATE_DETAILS_APP,
    APP_COUNTRIES,
    APP_REVOKE_PUBLISH,
    // SHOW_FORM_MODAL_CONFIRMATION,
    APP_VEHICLES,
    APP_VERSION_DETAILS,
    UPDATE_TEST_CREDENTIAL,
    SUB_HEADER_TEXT,
    SUB_HEADER_TITLE,
    NO_RESULT_FOUND,
    UPLOAD_CERTIFICATE
} from "../actions/apps/types";
import { AnyAction } from "redux";
import { Reducer } from "react";
import { AppsPageDetails } from "../models";

const initialState: AppsPageDetails = {
    noResultFound: false,
    details: {
        category: null,
        createdAt: "",
        description: null,
        icon: "",
        id: "",
        name: "",
        regions: [],
        screenshots: [],
        shortDescription: null,
        supportUrl: null,
        updatedAt: "",
        versions: [],
        videos: [],
        versionCode: "",
        versionName: "",
        status: null,
        news: 0,
        versionId: 0,
        isDefaultIcon: false,
        webUrl: null,
        countries: [],
        oemAppStatus: 0,
        vehicles: [],
        testerCredentials: {
            username: "",
            password: "",
        },
        headerText:
            "Please take time to configure your application correctly in order to submit it to the app store, where our validation team will ensure everything is in order to place your app within reach of our automotive users.",
        headerTitle: "",
        age_rating_id: 0,
    },
};

const appDetailsReducer: Reducer<AppsPageDetails, AnyAction> = (
    appsPageDetails = initialState,
    action: AnyAction
) => {
    const { type, payload } = action;

    switch (type) {
        case APP_BY_ID:
            return {
                ...appsPageDetails,
                details: payload.data,
            };

        case APP_VERSION_DETAILS:
            return {
                ...appsPageDetails,
                details: {
                    ...appsPageDetails.details,
                    versions: payload,
                },
            };

        case UPDATE_DETAILS_APP:
            return {
                ...appsPageDetails,
                details: {
                    ...appsPageDetails.details,
                    ...payload.data,
                },
            };

        case APP_SCREENSHOTS:
            return {
                ...appsPageDetails,
                details: {
                    ...appsPageDetails.details,
                    screenshots: payload,
                },
            };

        case APP_VIDEO:
            return {
                ...appsPageDetails,
                details: {
                    ...appsPageDetails.details,
                    videos: payload,
                },
            };

        case APP_ICON:
            return {
                ...appsPageDetails,
                details: {
                    ...appsPageDetails.details,
                    icon: payload.icon.url,
                },
            };

        case APP_VERSIONS:
            return {
                ...appsPageDetails,
                details: {
                    ...appsPageDetails.details,
                    versions: payload,
                },
            };

        case APP_COUNTRIES:
            return {
                ...appsPageDetails,
                details: {
                    ...appsPageDetails.details,
                    countries: payload,
                },
            };

        case APP_VEHICLES:
            return {
                ...appsPageDetails,
                details: {
                    ...appsPageDetails.details,
                    vehicles: payload,
                },
            };

        case APP_REVOKE_PUBLISH:
            return {
                ...appsPageDetails,
                details: {
                    ...appsPageDetails.details,
                    oemAppStatus: payload.status,
                },
            };
        case UPDATE_TEST_CREDENTIAL:
            return {
                ...appsPageDetails,
                details: {
                    ...appsPageDetails.details,
                    testerCredentials: payload,
                },
            };
        case SUB_HEADER_TEXT:
            return {
                ...appsPageDetails,
                details: {
                    ...appsPageDetails.details,
                },
                headerText: payload,
            };
        case SUB_HEADER_TITLE:
            console.log("Setting tittle", payload);
            return {
                ...appsPageDetails,
                details: {
                    ...appsPageDetails.details,
                },
                headerTitle: payload,
            };
        case NO_RESULT_FOUND:
            return {
                ...appsPageDetails,
                noResultFound: payload.status,
            };
        case UPLOAD_CERTIFICATE:
            return {
                ...appsPageDetails,
                uploadedCertificate: payload,
            };
        //case SHOW_FORM_MODAL_CONFIRMATION:
        //  return {
        //      ...appsPageDetails,
        //      isFormConfirmationShow: payload.data
        //  }

        default:
            return appsPageDetails;
    }
};

export default appDetailsReducer;
